import axios from "axios"

const paramsSerializer = (params) => {
    const Qs = require("qs")
    return Qs.stringify(params, { encode: false })
}

export const getVerifyOTPPhone = (headers, params) => {
    return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/verification/generate-otp-phone`, {
        headers,
        params,
        paramsSerializer
    })
}

export const confirmVerifyPhone = (headers, params, data) => {
    return axios.post(`${process.env.REACT_APP_MANAGEMENT_API_URL}/verification/phone`,
        data,
        {
            headers,
            params,
            paramsSerializer
        })
}

export const getOTPVerifyEmail = (headers, params) => {
    return axios.get(`${process.env.REACT_APP_MANAGEMENT_API_URL}/verification/generate-otp-email`, {
        headers,
        params,
        paramsSerializer
    })
}

export const confirmVerifyEmail = (headers, params, data) => {
    return axios.post(`${process.env.REACT_APP_MANAGEMENT_API_URL}/verification/email`,
        data,
        {
            headers,
            params,
            paramsSerializer
        })
}